import PageLoaderProvider from './PageLoaderProvider';

export * from './PageLoaderProvider';

export default PageLoaderProvider;
